import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";
import { getPanelHeader } from "./DashboardPanelFunctions";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getLoginsForUser, getMonthName} from "root/DataFunctions/DashboardDataFns";
import {UserTypes} from "root/DataFunctions/Constants";
import {dashboardDefaults, defaultTitleFontSize} from "root/dashboard/DashboardDefault";

const DashboardPanelChildLogins = (props) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;

	useEffect(() =>
	{
		getServerData() ;
	}, [props.month]);

    const generateDataPoints = ( items ) =>
	{
		return items.map ((item) =>
			{
				const key = item.monkey;
				const yr = key.substring ( 0, 4 );
				const mo = (key.substring (  4, 7 )) - 1;
				const monthName = getMonthName(+mo);
				const shortMonth = monthName.substring(0,3);
				const label = shortMonth + ' ' + yr ;

				return ({
					label: label,
					y: Number(item.count),
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getLoginsForUser( props.child_uid,  UserTypes.CHILD, props.month, props.year,(response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanel = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			...dashboardDefaults,
			title: {
				text: props.title,
				fontSize: defaultTitleFontSize
			},
			data: [
				{
					type: 'column',
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Logins',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ getPanelHeader({ title: props.title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartChildLogins' options={options} uniqueId='chartChildLogins' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelChildLogins;

DashboardPanelChildLogins.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}